const initializeSmCustomSelect = ($select) => {
    const $selectHead = $select.querySelector('.sm-custom-select--head');

    $selectHead.addEventListener('click', () => toggleDropdownState($select));
    document.addEventListener('click', (e) => closeOnDropdownsBodyClick(e.target, $select));
};

const toggleDropdownState = ($select) => {
    if ($select.getAttribute('data-sm-custom-select-dropdown') === 'closed') {
        $select.setAttribute('data-sm-custom-select-dropdown', 'open');
    } else {
        $select.setAttribute('data-sm-custom-select-dropdown', 'closed');
    }
};

const closeOnDropdownsBodyClick = ($clickTarget, $select) => {
    if ($clickTarget === $select) {
        return;
    }

    // ensures the dropdown is opened when clicking on the dropdown head
    const $dropdownHead = $select.querySelector('.sm-custom-select--head');
    if ($dropdownHead === $clickTarget) {
        return;
    }

    const $dropdownItems = $select.querySelectorAll('.sm-custom-select--item');
    for (const $item in $dropdownItems) {
        if ($clickTarget === $item) {
            return;
        }
    }

    $select.setAttribute('data-sm-custom-select-dropdown', 'closed');
};

export default () => {
    const $smCustomSelects = document.body.querySelectorAll('.sm-custom-select');

    if ($smCustomSelects) {
        Array.prototype.forEach.call($smCustomSelects, initializeSmCustomSelect);
    }
};
